import axios from "axios"
import getAuthorization from "api/get-authorization"

const apiClient = ({ token } = {}) => {
  const headers = {
    "Content-Type": "application/json",
  }

  const authorization = getAuthorization(token)

  if (authorization) {
    headers["Authorization"] = authorization
  }

  return axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    headers,
  })
}

export default apiClient
